/* globals localStorage */

import Api from "./api";

async function authLogin(username, password) {
  let res;
  try {
    const data = await Api.getJSON("post", "login", {
      username: username,
      password: password
    });
    res = { sesid: data.sesid };
  } catch (error) {
    res = { authError: Api.getFirstError(error) };
  }
  return res;
}

async function authLogout() {
  try {
    await Api.getJSON("get", "logout");
  } catch (error) {
    // Empty
  }
}

export default {
  async login(username, password, cb) {
    const res = await authLogin(username, password);
    if (res.sesid != null) {
      localStorage.setItem("sesid", res.sesid);
      if (cb) cb(true);
      this.onChange(true);
    } else {
      localStorage.removeItem("sesid");
      if (cb) cb(false, res.authError);
      this.onChange(false);
    }
  },

  async logout(cb) {
    if (localStorage.getItem("sesid") != null) {
      await authLogout();
    }
    localStorage.removeItem("sesid");
    if (cb) cb();
    this.onChange(false);
  },

  getSesId() {
    return localStorage.getItem("sesid");
  },

  loggedIn() {
    return localStorage.getItem("sesid") != null;
  },

  onChange() {}
};
